import React, { Component } from "react";
import { MDBIcon } from "mdbreact";
import { admission, mua, site } from "../../config/api";

import axios from "axios";
import PresentLayout, { PresentHubCards } from "./PresentLayout";

export default class Present extends Component {
  constructor(props) {
    super(props);
    this.state = {
      REGISTER_ID: null,
      REGISTER_TYPE_ID: null,
      ShowlistnotInsert: true,
      ShowlistnotInsert1: false,
      ShowlistnotInsert2: false,
      ShowlistnotInsert3: false,
      ShowlistnotInsert4: false,
      ShowlistnotInsert5: false,
      ShowlistnotInsert6: false,
      ShowlistnotInsert7: false,
      ShowlistnotInsert8: false,
      ShowlistnotInsert9: false,
      ShowlistnotInsert9_1: 0,
      ShowlistnotInsert10: false,
      Numprogress: 0,
      rows: [],
      ShowfileUpload: [],
      MOJOR_ID: null,
      listmoneyonline: [],
      chk: false,
      allowpayactivity: false,
    };
  }

  componentDidMount() {
    // axios.get(admission + "/student/loadpresent/"+localStorage.getItem("ID_LOGIN")).then((res) => {
    const getdata = async () => {
      const url = await axios.get(
        admission + "/student/loadpresent/" + localStorage.getItem("ID_LOGIN")
      );
      let data = url.data;
      data = (Array.isArray(data) ? data : []).filter(
        ({ REGISTER_STATUS }) => !(REGISTER_STATUS === "11")
      );
      if (!data.length) {
        this.setState({ chk: true });
        return;
      }
      this.setState({ rows: data[0] });
      this.setState({ MOJOR_ID: data[0]["MOJOR_ID"] });
      this.setState({ REGISTER_TYPE_ID: data[0]["REGISTER_TYPE_ID"] });
      this.creckprecent(data[0]["REGISTER_ID"]);
      try {
        const urlmoney = await axios.get(
          mua +
            "/admission/getEligibleInterviewReports_new/" +
            data[0]["CITIZENT_LOGIN"] +
            "/" +
            data[0]["REGISTER_STATUS"] +
            "/" +
            data[0]["ROB_ID"] +
            "/" +
            data[0]["REGISTER_ID"]
        );
        const datamoney = urlmoney.data;
        this.setState({ listmoneyonline: Array.isArray(datamoney) ? datamoney[0] : datamoney });
      } catch (e) {
        this.setState({ listmoneyonline: [] });
      }
      this.setState({ chk: true });
    };
    // axios.get(admission + "/student/loadpresent/" + localStorage.getItem("ID_LOGIN")).then((res) => {
    //   res.data = res.data.filter(({ REGISTER_STATUS }) => !(REGISTER_STATUS === "11"));
    //   this.setState({ rows: res.data[0] });
    //   this.setState({ MOJOR_ID: res.data[0]["MOJOR_ID"] });
    //   this.setState({ REGISTER_TYPE_ID: res.data[0]["REGISTER_TYPE_ID"] });
    //   this.creckprecent(res.data[0]["REGISTER_ID"]);
    //   axios
    //     .get(mua + "/admission/getEligibleInterviewReports_new/" + res.data[0]["CITIZENT_LOGIN"] + "/" + res.data[0]["REGISTER_STATUS"] + "/" + res.data[0]["ROB_ID"] + "/" + res.data[0]["REGISTER_ID"])
    //     .then((response_money) => {
    //       this.setState({ listmoneyonline: response_money.data[0] });
    //     });
    // });
    let [day, month, year] = ["25", "04", "2025"];
    let [days, months, years] = ["22", "04", "2025"];
    if (parseInt(year) > 2400) {
      year = (parseInt(year) - 543).toString();
    }
    const textDate = `${month}/${day}/${year} 23:59`;
    const textDates = `${months}/${days}/${years} 23:59`;
    const startdate = new Date(textDate);
    const enddate = new Date(textDates);
    const datenow = new Date();
    if (startdate <= datenow && datenow <= enddate) {
      console.log("มากกว่า");
    }
    getdata();
  }

  creckprecent(id) {
    // axios.get(admission + "/student/creckprecent1/" + id).then((response) => {
    axios.get(admission + "/student/creckprecent1/" + id).then((response) => {
      if (response.data === 0) {
        this.setState({ ShowlistnotInsert1: true });
        this.setState({ ShowlistnotInsert: true });
      } else {
        this.setState({ Numprogress: parseInt(this.state.Numprogress) + parseInt(18) });
      }
    });

    axios.get(admission + "/student/creckprecent2/" + id).then((response) => {
      if (response.data === 0) {
        this.setState({ ShowlistnotInsert2: true });
        this.setState({ ShowlistnotInsert: true });
      } else {
        //  if(this.state.REGISTER_TYPE_ID === '7'){
        //         axios.post(admission + "/student_insertpresent2/loadvutTor",{
        //             OLDID:id
        //         }).then((res)=>{
        //             const count = res.data
        //             if(count.length === 0){
        //                 this.setState({ ShowlistnotInsert2: true });
        //                 this.setState({ ShowlistnotInsert: true });
        //             }else{
        //                 this.setState({ Numprogress: parseInt(this.state.Numprogress) + parseInt(18) });
        //             }
        //         })
        //     }else{
        this.setState({ Numprogress: parseInt(this.state.Numprogress) + parseInt(18) });
        // }
      }
    });

    axios.get(admission + "/student/creckprecent3/" + id).then((response) => {
      if (response.data === 0) {
        this.setState({ ShowlistnotInsert3: true });
        this.setState({ ShowlistnotInsert: true });
      } else {
        this.setState({ Numprogress: parseInt(this.state.Numprogress) + parseInt(18) });
      }
    });

    axios.get(admission + "/student/creckprecent4/" + id).then((response) => {
      if (response.data === 0) {
        this.setState({ ShowlistnotInsert4: true });
        this.setState({ ShowlistnotInsert: true });
      } else {
        this.setState({ Numprogress: parseInt(this.state.Numprogress) + parseInt(13) });
      }
    });

    axios.get(admission + "/student/creckprecent5/" + id).then((response) => {
      if (response.data === 0) {
        this.setState({ ShowlistnotInsert5: true });
        this.setState({ ShowlistnotInsert: true });
      } else {
        this.setState({ Numprogress: parseInt(this.state.Numprogress) + parseInt(13) });
      }
    });

    axios.get(admission + "/student/creckprecent6/" + id).then((response) => {
      if (response.data === 0) {
        this.setState({ ShowlistnotInsert6: true });
        this.setState({ ShowlistnotInsert: true });
      } else {
        this.setState({ Numprogress: parseInt(this.state.Numprogress) + parseInt(5) });
      }
    });

    axios.get(admission + "/student/creckprecent7/" + id).then((response) => {
      if (response.data === 0) {
        this.setState({ ShowlistnotInsert7: true });
        this.setState({ ShowlistnotInsert: true });
      } else {
        this.setState({ Numprogress: parseInt(this.state.Numprogress) + parseInt(5) });
      }
    });

    axios
      .get(admission + "/student/creckprecent8/" + localStorage.getItem("ID_LOGIN"))
      .then((response) => {
        if (response.data === 0) {
          this.setState({ ShowlistnotInsert8: true });
          this.setState({ ShowlistnotInsert: true });
        } else {
          axios
            .get(
              admission +
              "/student_insertpresent8/ShowfileUpload/" +
              localStorage.getItem("ID_LOGIN")
            )
            .then((res) => {
              if (res.data.length !== 0) {
                if (
                  res.data[0]["UPLOAD_LOGIN"] === null ||
                  res.data[0]["UPLOAD_LOGIN"] === "" ||
                  res.data[0]["UPLOAD_LOGIN"] === undefined ||
                  res.data[0]["UPLOAD_LOGIN"] === "null" ||
                  res.data[0]["UPLOAD_LOGIN_STATUS"] === "0"
                ) {
                  this.setState({ ShowlistnotInsert8: true });
                  this.setState({ ShowlistnotInsert: true });
                } else {
                  this.setState({ Numprogress: parseInt(this.state.Numprogress) + parseInt(5) });
                }
              }
            });
        }
      });
    if (this.state.rows.LEVEL_OPEN_ID !== "4" && this.state.rows.LEVEL_OPEN_ID !== "19") {
      axios
        .get(admission + "/student/creckprecent9/" + localStorage.getItem("ID_LOGIN"))
        .then((response) => {
          if (response.data === 0) {
            this.setState({ ShowlistnotInsert9: true });
            this.setState({ ShowlistnotInsert: true });
          } else {
            this.setState({ Numprogress: parseInt(this.state.Numprogress) + parseInt(5) });
          }
        });
    } else {
      axios
        .get(admission + "/student/creckprecent9/" + localStorage.getItem("ID_LOGIN"))
        .then((response) => {
          if (response.data === 0) {
            this.setState({ ShowlistnotInsert9: true });
            this.setState({ ShowlistnotInsert: true });
          } else {
            this.setState({ Numprogress: parseInt(this.state.Numprogress) + parseInt(2) });
          }
        });
      axios
        .get(admission + "/student/creckprecent10/" + localStorage.getItem("ID_LOGIN"))
        .then((response) => {
          if (response.data === 0) {
            this.setState({ ShowlistnotInsert10: true });
            this.setState({ ShowlistnotInsert: true });
          } else {
            this.setState({ Numprogress: parseInt(this.state.Numprogress) + parseInt(3) });
          }
        });
    }

    axios
      .get(admission + "/student/creckprecent9_1/" + localStorage.getItem("ID_LOGIN"))
      .then((response) => {
        console.log(response.data.DetailNumber);
        if (response.data.DetailNumber === 0) {
          this.setState({ ShowlistnotInsert9_1: 0 });
          this.setState({ ShowfileUpload: response.data.DetailList });
        } else {
          this.setState({ ShowlistnotInsert9_1: 1 });
        }
      });
  }

  render() {
    const rows = this.state.rows || {};
    const includeTpat = rows.LEVEL_OPEN_ID === "4" || rows.LEVEL_OPEN_ID === "19";
    const stepsStatus = {
      1: this.state.ShowlistnotInsert1,
      2: this.state.ShowlistnotInsert2,
      3: this.state.ShowlistnotInsert3,
      4: this.state.ShowlistnotInsert4,
      5: this.state.ShowlistnotInsert5,
      6: this.state.ShowlistnotInsert6,
      7: this.state.ShowlistnotInsert7,
      8: this.state.ShowlistnotInsert8,
      9: this.state.ShowlistnotInsert9,
      10: this.state.ShowlistnotInsert10,
    };
    const progress = Math.min(100, Number(this.state.Numprogress) || 0);

    return (
      <PresentLayout
        title="ข้อมูลรายงานตัว"
        metaTitle="ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร"
        showRequiredHint={false}
        includeTpat={includeTpat}
      >
        <dl className="present-hub__profile">
          <div>
            <dt>รหัสประจำตัวผู้สมัคร</dt>
            <dd>{rows.REGISTER_ID || "-"}</dd>
          </div>
          <div>
            <dt>ชื่อ - นามสกุล</dt>
            <dd>
              {rows.FULLNAME || ""}
              {rows.FRISTNAME_LOGIN} {rows.LASTNAME_LOGIN}
            </dd>
          </div>
          <div>
            <dt>สาขาวิชา</dt>
            <dd>
              {rows.MOJOR_ID} {rows.MAJOR_NAME || "-"}
            </dd>
          </div>
          <div>
            <dt>คณะ</dt>
            <dd>{rows.faculty_name || "-"}</dd>
          </div>
          <div>
            <dt>ระดับการศึกษา</dt>
            <dd>{rows.LEVEL_OPEN_NAME || "-"}</dd>
          </div>
          <div>
            <dt>ประเภท</dt>
            <dd>{rows.QUOTA_NAME || "-"}</dd>
          </div>
        </dl>

        <div className="present-hub__progress-label">
          <span>ความคืบหน้าการกรอกข้อมูลรายงานตัว</span>
          <strong>{progress}%</strong>
        </div>
        <div className="present-hub__bar" aria-hidden="true">
          <i style={{ width: `${progress}%` }} />
        </div>

        <p className="present-hub__hint">
          เลือกหัวข้อที่ยังไม่ครบเพื่อกรอกข้อมูล หรือแก้ไขรายการที่กรอกแล้วได้ตลอดเวลา
        </p>
        <PresentHubCards stepsStatus={stepsStatus} includeTpat={includeTpat} />

        <div className="present-hub__section">
                          {this.state.Numprogress === 100 &&
                            this.state.ShowlistnotInsert9_1 === 1 ? (
                            <>
                              {this.state.REGISTER_TYPE_ID === "1" ||
                                this.state.REGISTER_TYPE_ID === "5" ? (
                                <>
                                  <div className="alert alert-success " style={{ fontSize: 20 }}>
                                    สามารถพิมพ์ใบรายงานตัวพร้อมบัตรนักศึกษา ได้ตั้งแต่ 14 - 21 พฤษภาคม 2569 เป็นต้นไป
                                  </div>
                                </>
                              ) : (
                                <>
                                  {this.state.REGISTER_TYPE_ID === "2" ||
                                    this.state.REGISTER_TYPE_ID === "3" ? (
                                    <>
                                      <div className="alert alert-warning">
                                        {/* สามารถพิมพ์ใบรายงานตัวและบัตรนักศึกษาชั่วคราว ได้ตั้งแต่วันที่ 24 กรกฎาคม 2566
                                        เป็นต้นไป */}
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {this.state.MOJOR_ID === "9903" ||
                                        this.state.REGISTER_TYPE_ID === "7" ||
                                        this.state.REGISTER_TYPE_ID === "4" ? (
                                        <>
                                        <>
                                  <div className="alert alert-success " style={{ fontSize: 20 }}>
                                    สามารถพิมพ์ใบรายงานตัวพร้อมบัตรนักศึกษา ได้ตั้งแต่ 14 - 21 พฤษภาคม 2569 เป็นต้นไป
                                  </div>
                                </>
                                        </>
                                      ) : (
                                        <>
                                        
                                          {/* <a href={admission + "/student_printpresent?code_test=" + this.state.rows.REGISTER_ID} class="btn btn-success btn-lg btn-block" hidden={this.state.rows.REGISTER_STDID ? false : true} role="button" target="_blank"><span class="glyphicon glyphicon-print"></span> พิมพ์ใบรายงานตัว</a> */}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                          {this.state.rows.REGISTER_STATUS >= 9 &&
                            this.state.rows.REGISTER_STDID >= 64 &&
                            this.state.Numprogress === 100 &&
                            this.state.ShowlistnotInsert9_1 === 1 ? (
                            <>
                              {this.state.Numprogress >= 100 &&
                                this.state.ShowlistnotInsert9_1 === 1 ? (
                                <>
                                  <div
                                    className="d-flex justify-content-center align-items-center flex-column flex-lg-row "
                                    style={{ gap: 5 }}
                                  >
                                    <a
                                      href={
                                        admission + "/administrator_printreportcard?oldid=" +
                                        this.state.rows.REGISTER_STDID
                                      }
                                      class="btn btn-warning btn-lg btn-block"
                                      hidden={this.state.rows.REGISTER_STDID ? false : true}
                                      role="button"
                                      target="_blank"
                                    >
                                      <span class="glyphicon glyphicon-print"></span>{" "}
                                      พิมพ์บัตรนักศึกษาชั่วคราว
                                    </a>
                                    <a
                                      href={
                                        admission + "/student_printpresent?code_test=" +
                                        this.state.rows.REGISTER_ID
                                      }
                                      class="btn btn-success btn-lg btn-block"
                                      hidden={this.state.rows.REGISTER_STDID ? false : true}
                                      role="button"
                                      target="_blank"
                                    >
                                      <span class="glyphicon glyphicon-print "></span>{" "}
                                      พิมพ์ใบรายงานตัว
                                    </a>

                                    {/* {(this.state.REGISTER_TYPE_ID === "1" ||
                                      this.state.REGISTER_TYPE_ID === "5") && (
                                        <a
                                          href={
                                            "https://e-payment.kpru.ac.th/pay/typepayment?comp=81914&orderRef1=" +
                                            this.state.rows.REGISTER_ID +
                                            "&amount=800&endDate=30/06/2568&urlredirect=" + site + "/present&term=1/" +
                                            this.state.rows.ROB_YEAR +
                                            "&name=" +
                                            this.state.rows.FULLNAME +
                                            this.state.rows.FRISTNAME_LOGIN +
                                            "&lname=" +
                                            this.state.rows.LASTNAME_LOGIN
                                          }
                                          class="btn btn-primary btn-lg btn-block"
                                          role="button"
                                          target="_blank"
                                        >
                                          ชำระค่าปฐมนิเทศ
                                        </a>
                                      )} */}
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                          <div
                            onClick={(e) => {
                              window.location.pathname = `${process.env.REACT_APP_BASENAME || ""}/waiver`;
                            }}
                            class="btn btn-danger btn-lg btn-block mt-3 "
                            // hidden={this.state.rows.REGISTER_STDID ? false : true}
                            role="button"
                            target="_blank"
                          >
                            <span class="glyphicon glyphicon-print "></span>{" "}
                            แบบฟอร์มขอสละสิทธิ์การเข้าศึกษา
                          </div>
                          {this.state.Numprogress === 100 &&
                            this.state.ShowlistnotInsert9_1 === 0 ? (
                            <>
                              <div className="alert alert-warning">
                                เอกสารการรายงานตัวอยู่ระหว่างการตรวจสอบ
                                สามารถเข้าตรวจสอบความถูกต้องได้อีกครั้งภายใน 7 วัน
                              </div>

                              <table className="table table-hover">
                                <thead>
                                  <tr className="table-info">
                                    <th style={{ textAlign: "center" }}>#</th>
                                    <th style={{ textAlign: "center" }}>
                                      เอกสารประกอบการรายงานตัว
                                    </th>
                                    <th style={{ textAlign: "center" }}>สถานะการตรวจสอบ</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.ShowfileUpload.map((data, index) => {
                                    return (
                                      <tr>
                                        <td>{index + 1}</td>
                                        <td>{data.DOCUMENT_TYPE_NAME}</td>
                                        {data.Files !== null ? (
                                          <>
                                            {data.FilesStatus === "1" ? (
                                              <>
                                                <td className="text-success">
                                                  <MDBIcon icon="check" /> ผ่านการตรวจสอบ
                                                </td>
                                              </>
                                            ) : (
                                              <>
                                                {data.FilesStatus === "0" ? (
                                                  <>
                                                    <td className="text-danger">
                                                      <MDBIcon icon="times" />{" "}
                                                      ไม่ผ่านการตรวจสอบเนื่องจาก {data.FilesDetail}
                                                    </td>
                                                    {data.DOCUMENT_TYPE_NAME ===
                                                      "รูปประจำตัวผู้สมัคร" ? (
                                                      <td className="black-text text-center">
                                                        <a
                                                          href="insertpresent8"
                                                          className="btn btn-warning btn-sm"
                                                          role="button"
                                                        >
                                                          คลิกเพื่อดำเนินการปรับปรุงรูปประจำตัวผู้สมัคร
                                                        </a>
                                                      </td>
                                                    ) : (
                                                      <td className="black-text text-center">
                                                        <a
                                                          href="insertpresent9"
                                                          className="btn btn-warning btn-sm"
                                                          role="button"
                                                        >
                                                          คลิกเพื่อดำเนินการปรับปรุงเอกสาร
                                                        </a>
                                                      </td>
                                                    )}
                                                  </>
                                                ) : (
                                                  <>
                                                    {data.FilesStatus === null ? (
                                                      <>
                                                        <td className="text-warning">
                                                          <MDBIcon icon="sync-alt" />{" "}
                                                          อยู่ระหว่างการตรวจสอบ
                                                        </td>
                                                      </>
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            )}
                                          </>
                                        ) : data.DOCUMENT_TYPE_ID === "5" &&
                                          data.FilesStatus === "2" &&
                                          data.Files === null ? (
                                          <>
                                            <td className="text-success">
                                              <MDBIcon icon="check" />
                                              ไม่มีไฟล์เอกสารการเปลี่ยนชื่อ-นามสกุล
                                            </td>
                                          </>
                                        ) : (
                                          <>
                                            <td className="black-text">
                                              <MDBIcon icon="file-upload" /> ไม่ได้อัพโหลดเอกสาร
                                            </td>
                                          </>
                                        )}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </>
                          ) : (
                            <></>
                          )}

                          {this.state.Numprogress !== 101 ? (
                            <>
                              <div>
                                <br />
                                <div className="alert alert-danger">
                                  <h4 className="black-text">
                                    ข้อควรระวังในการดาวน์โหลดเอกสารใบเสร็จรับเงินค่าบำรุงการศึกษา
                                    มหาวิทยาลัยราชภัฏกำแพงเพชร
                                  </h4>
                                  <ul>
                                    <li>
                                      หากดาวน์โหลดเอกสารใบเสร็จรับเงินค่าบำรุงการศึกษา
                                      มหาวิทยาลัยราชภัฏกำแพงเพชรเป็นครั้งแรก
                                      ใบเสร็จจะเป็นฉบับตัวจริงสามารถใช้ประกอบการเบิกค่าธรรมการศึกษาจากหน่วยงานราชการได้
                                    </li>
                                    <li>
                                      หากดาวน์โหลดเอกสารใบเสร็จรับเงินค่าบำรุงการศึกษา
                                      มหาวิทยาลัยราชภัฏกำแพงเพชรครั้งถัดไป เอกสารจะแสดงข้อความ
                                      "ฉบับสำเนา"
                                    </li>
                                  </ul>
                                </div>
                                <br />
                                <table className="table table-hover">
                                  <thead>
                                    <tr className="table-info">
                                      <th>รูปแบบการชำระค่าธรรมเนียมทางการศึกษา</th>
                                      <th>ดาวน์โหลดไฟล์</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.rows.REGISTER_STATUS_BILL_ROBFULL_BOOK === null &&
                                      this.state.rows.REGISTER_STATUS_BILL_ROBFULL_NO === null ? (
                                      <>
                                        <tr>
                                          <td>
                                            {this.state.rows.REGISTER_TYPE_ID === "6" ? (
                                              <>
                                                ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษาแบบแบ่งจ่าย 3 งวด
                                                (งวดที่ 1)
                                              </>
                                            ) : (
                                              <>
                                                ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษาแบบแบ่งจ่าย 2 งวด
                                                (งวดที่ 1)
                                              </>
                                            )}
                                          </td>
                                          <td>
                                            {this.state.rows.REGISTER_STATUS_BILL_ROB1_BOOK ===
                                              null && this.state.rows.ROB_ID === "107" ? (
                                              <>
                                                <a
                                                  type="button"
                                                  className="btn btn-warning btn-xs"
                                                  href={
                                                    "https://e-payment.kpru.ac.th/pay/typepayment?comp=80427&orderRef1=" +
                                                    this.state.listmoneyonline.REGISTER_ID +
                                                    "&amount=" +
                                                    this.state.listmoneyonline.SALARY_MONEY_1 +
                                                    "&endDate=" +
                                                    this.state.listmoneyonline.SALARY_DATE_CLOSE +
                                                    "&urlredirect=" + admission + "/student&term=1/" +
                                                    this.state.listmoneyonline.years +
                                                    "&name=" +
                                                    this.state.listmoneyonline.FULLNAME +
                                                    this.state.listmoneyonline.FRISTNAME_LOGIN +
                                                    "&lname=" +
                                                    this.state.listmoneyonline.LASTNAME_LOGIN
                                                  }
                                                >
                                                  ชำระเงินค่าธรรมเนียมการศึกษาแบบแบ่งจ่าย 3 งวด
                                                  (งวดที่ 1) ผ่านช่องทางออนไลน์
                                                </a>
                                                <a
                                                  href={
                                                    admission + "/student_printbill?code_test=" +
                                                    this.state.rows.REGISTER_ID +
                                                    "&typebill=1&ad=1"
                                                  }
                                                  target="_blank"
                                                  className="btn btn-success btn-xs"
                                                  role="button"
                                                >
                                                  ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษาแบบแบ่งจ่าย 3
                                                  งวด (งวดที่ 1)
                                                </a>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                            {this.state.rows.REGISTER_STATUS_BILL_ROB1_BOOK !==
                                              null &&
                                              this.state.rows.REGISTER_STATUS_BILL_ROB1_NO !==
                                              null ? (
                                              <>
                                                <a
                                                  href={
                                                    "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROB1_BOOK_YEAR +
                                                    "&BOOK_NO=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROB1_BOOK_BOOK +
                                                    "&ID_NO=" +
                                                    this.state.rows.REGISTER_ID +
                                                    "&NO=" +
                                                    this.state.rows.REGISTER_STATUS_BILL_ROB1_NO +
                                                    "&typeuser=2&countbill=" +
                                                    this.state.rows.REGISTER_STATUS_BILL_ROB1_COUNT
                                                  }
                                                  target="_blank"
                                                  className="btn btn-primary btn-xs"
                                                  role="button"
                                                >
                                                  ดาวน์โหลดไฟล์ใบเสร็จรับเงินงวดที่ 1
                                                </a>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </td>
                                        </tr>
                                      </>
                                    ) : (
                                      <></>
                                    )}

                                    {this.state.rows.REGISTER_STATUS_BILL_ROB1_BOOK !== null &&
                                      this.state.rows.REGISTER_STATUS_BILL_ROB1_NO !== null ? (
                                      <>
                                        <tr>
                                          <td>
                                            {this.state.rows.REGISTER_TYPE_ID === "6" ? (
                                              <>
                                                ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษาแบบแบ่งจ่าย 3 งวด
                                                (งวดที่ 2)
                                              </>
                                            ) : (
                                              <>
                                                ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษาแบบแบ่งจ่าย 2 งวด
                                                (งวดที่ 2)
                                              </>
                                            )}
                                          </td>
                                          <td>
                                            {this.state.rows.REGISTER_STATUS_BILL_ROB2_BOOK ===
                                              null && (this.state.rows.ROB_ID === "169" || this.state.rows.ROB_ID === "172") ? (
                                              <>

                                                <a href={admission + "/student_printbill?code_test=" + this.state.rows.REGISTER_ID + "&typebill=2&ad=1"} target="_blank" class="btn btn-success btn-xs " role="button">ดาวน์โหลดไฟล์ใบแจ้งชำระเงินงวดที่ 2 </a>
                                                {/* <div
                                               
                                                  href={
                                                    admission + "/student_printbill?code_test=" +
                                                    this.state.rows.REGISTER_ID +
                                                    "&typebill=2&ad=1"
                                                  }
                                                  target="_blank"
                                                  class="btn btn-success btn-xs  "
                                                  role="button"
                                                >
                                                  ดาวน์โหลดไฟล์ใบแจ้งชำระเงินงวดที่ 2{" "}
                                                </div> */}
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                            {this.state.rows.REGISTER_STATUS_BILL_ROB2_BOOK !==
                                              null &&
                                              this.state.rows.REGISTER_STATUS_BILL_ROB2_NO !==
                                              null ? (
                                              <>
                                                <a
                                                  href={
                                                    "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROB2_BOOK_YEAR +
                                                    "&BOOK_NO=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROB2_BOOK_BOOK +
                                                    "&ID_NO=" +
                                                    this.state.rows.REGISTER_ID +
                                                    "&NO=" +
                                                    this.state.rows.REGISTER_STATUS_BILL_ROB2_NO +
                                                    "&typeuser=2&countbill=" +
                                                    this.state.rows.REGISTER_STATUS_BILL_ROB2_COUNT
                                                  }
                                                  target="_blank"
                                                  class="btn btn-primary btn-xs disable"
                                                  role="button"
                                                >
                                                  ดาวน์โหลดไฟล์ใบเสร็จรับเงินงวดที่ 2{" "}
                                                </a>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </td>
                                        </tr>
                                      </>
                                    ) : (
                                      <></>
                                    )}

                                    {this.state.rows.REGISTER_STATUS_BILL_ROB2_BOOK !== null &&
                                      this.state.rows.REGISTER_STATUS_BILL_ROB2_NO !== null &&
                                      this.state.rows.REGISTER_TYPE_ID === "6" ? (
                                      <>
                                        <tr>
                                          <td>
                                            ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษาแบบแบ่งจ่าย 3 งวด
                                            (งวดที่ 3)
                                          </td>
                                          <td>
                                            {this.state.rows.REGISTER_STATUS_BILL_ROB3_BOOK ==
                                              null ? (
                                              <>
                                                <a
                                                  href={
                                                    admission + "/student_printbill?code_test=" +
                                                    this.state.rows.REGISTER_ID +
                                                    "&typebill=3&ad=1"
                                                  }
                                                  target="_blank"
                                                  class="btn btn-success btn-xs"
                                                  role="button"
                                                >
                                                  ดาวน์โหลดไฟล์ใบแจ้งชำระเงินงวดที่ 3
                                                </a>
                                              </>
                                            ) : (
                                              <></>
                                            )}

                                            {this.state.rows.REGISTER_STATUS_BILL_ROB3_BOOK !==
                                              null &&
                                              this.state.rows.REGISTER_STATUS_BILL_ROB3_NO !==
                                              null ? (
                                              <>
                                                <a
                                                  href={
                                                    "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROB2_BOOK_YEAR +
                                                    "&BOOK_NO=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROB2_BOOK_BOOK +
                                                    "&ID_NO=" +
                                                    this.state.rows.REGISTER_ID +
                                                    "&NO=" +
                                                    this.state.rows.REGISTER_STATUS_BILL_ROB2_NO +
                                                    "&typeuser=2&countbill=" +
                                                    this.state.rows.REGISTER_STATUS_BILL_ROB2_COUNT
                                                  }
                                                  target="_blank"
                                                  class="btn btn-primary btn-xs"
                                                  role="button"
                                                >
                                                  ดาวน์โหลดไฟล์ใบเสร็จรับเงินงวดที่ 3
                                                </a>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </td>
                                        </tr>
                                      </>
                                    ) : (
                                      <></>
                                    )}

                                    {this.state.rows.REGISTER_STATUS_BILL_ROB1_BOOK === null &&
                                      this.state.rows.REGISTER_STATUS_BILL_ROB1_NO === null ? (
                                      <>
                                        <tr>
                                          <td>ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษาทั้งหมด</td>
                                          <td>
                                            {this.state.rows.REGISTER_STATUS_BILL_ROB1_BOOK ===
                                              null &&
                                              this.state.rows.REGISTER_STATUS_BILL_ROBFULL_BOOK ===
                                              null &&
                                              this.state.rows.ROB_ID === "107" ? (
                                              <>
                                                <a
                                                  type="button"
                                                  class="btn btn-warning btn-xs"
                                                  href={
                                                    "https://e-payment.kpru.ac.th/pay/typepayment?comp=80427&orderRef1=" +
                                                    this.state.listmoneyonline.REGISTER_ID +
                                                    "&amount=" +
                                                    this.state.listmoneyonline.SALARY_MONEY_FULL +
                                                    "&endDate=" +
                                                    this.state.listmoneyonline.SALARY_DATE_CLOSE +
                                                    "&urlredirect=" + admission + "/student&term=1/" +
                                                    this.state.listmoneyonline.years +
                                                    "&name=" +
                                                    this.state.listmoneyonline.FULLNAME +
                                                    this.state.listmoneyonline.FRISTNAME_LOGIN +
                                                    "&lname=" +
                                                    this.state.listmoneyonline.LASTNAME_LOGIN
                                                  }
                                                >
                                                  ชำระเงินค่าธรรมเนียมการศึกษาแบบแบ่งจ่าย 3 งวด
                                                  (งวดที่ 1) ผ่านช่องทางออนไลน์
                                                </a>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                            {this.state.rows.REGISTER_STATUS_BILL_ROB1_BOOK ===
                                              null &&
                                              this.state.rows.REGISTER_STATUS_BILL_ROBFULL_BOOK ===
                                              null &&
                                              this.state.rows.ROB_ID === "107" ? (
                                              <>
                                                <a
                                                  href={
                                                    admission + "/student_printbill?code_test=" +
                                                    this.state.rows.REGISTER_ID +
                                                    "&typebill=4&ad=1"
                                                  }
                                                  target="_blank"
                                                  class="btn btn-success btn-xs"
                                                  role="button"
                                                >
                                                  ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษาทั้งหมด
                                                </a>
                                              </>
                                            ) : (
                                              <></>
                                            )}

                                            {this.state.rows.REGISTER_STATUS_BILL_ROBFULL_BOOK !==
                                              null &&
                                              this.state.rows.REGISTER_STATUS_BILL_ROBFULL_NO !==
                                              null ? (
                                              <>
                                                <a
                                                  href={
                                                    "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROBFULL_BOOK_YEAR +
                                                    "&BOOK_NO=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROBFULL_BOOK_BOOK +
                                                    "&ID_NO=" +
                                                    this.state.rows.REGISTER_ID +
                                                    "&NO=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROBFULL_NO +
                                                    "&typeuser=2&countbill=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROBFULL_COUNT
                                                  }
                                                  target="_blank"
                                                  class="btn btn-primary btn-xs"
                                                  role="button"
                                                >
                                                  ดาวน์โหลดไฟล์ใบเสร็จรับเงินค่าธรรมเนียมการศึกษาทั้งหมด
                                                </a>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </td>
                                        </tr>
                                      </>
                                    ) : (
                                      <></>
                                    )}

                                    {this.state.rows.REGISTER_STATUS_BILL_ROBDIFF_BOOK !== null &&
                                      this.state.rows.REGISTER_STATUS_BILL_ROBDIFF_NO !== null ? (
                                      <>
                                        <tr>
                                          <td>ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษาส่วนต่าง</td>
                                          <td>
                                            <a
                                              href={
                                                "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                                this.state.rows
                                                  .REGISTER_STATUS_BILL_ROBDIFF_BOOK_YEAR +
                                                "&BOOK_NO=" +
                                                this.state.rows
                                                  .REGISTER_STATUS_BILL_ROBDIFF_BOOK_BOOK +
                                                "&ID_NO=" +
                                                this.state.rows.REGISTER_ID +
                                                "&NO=" +
                                                this.state.rows.REGISTER_STATUS_BILL_ROBDIFF_NO +
                                                "&typeuser=2&countbill=" +
                                                this.state.rows.REGISTER_STATUS_BILL_ROBDIFF_COUNT
                                              }
                                              target="_blank"
                                              class="btn btn-primary btn-xs"
                                              role="button"
                                            >
                                              ดาวน์โหลดไฟล์ใบเสร็จรับเงินส่วนต่าง
                                            </a>
                                          </td>
                                        </tr>
                                      </>
                                    ) : (
                                      <>
                                        {this.state.listmoneyonline.length !== 0 && (
                                          <>
                                            {this.state.listmoneyonline["DIFF_URL"] === "ZERO" ? (
                                              <></>
                                            ) : (
                                              <>
                                                <tr>
                                                  <td>
                                                    ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษาส่วนต่าง
                                                  </td>
                                                  <td>
                                                    <a
                                                      href={this.state.listmoneyonline["DIFF_URL"]}
                                                      target="_blank"
                                                      class="btn btn-primary btn-xs"
                                                      role="button"
                                                    >
                                                      ดาวน์โหลดไฟล์ใบเสร็จรับเงินส่วนต่าง
                                                    </a>
                                                  </td>
                                                </tr>
                                              </>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}

                                    {this.state.rows.REGISTER_STATUS_BILL_ORIENTATIN_BOOK !==
                                      null &&
                                      this.state.rows.REGISTER_STATUS_BILL_ORIENTATIN_NO !== null &&
                                      (this.state.rows.REGISTER_TYPE_ID === "1" ||
                                        this.state.rows.REGISTER_TYPE_ID === "2" ||
                                        this.state.rows.REGISTER_TYPE_ID === "3" ||
                                        this.state.rows.REGISTER_TYPE_ID === "5") ? (
                                      <>
                                        <tr>
                                          <td>ใบเสร็จชำระค่าปฐมนิเทศนักศึกษาใหม่</td>
                                          <td>
                                            {this.state.rows
                                              .REGISTER_STATUS_BILL_ORIENTATIN_BOOK !== null &&
                                              this.state.rows.REGISTER_STATUS_BILL_ORIENTATIN_NO !==
                                              null ? (
                                              <>
                                                <a
                                                  href={
                                                    "https://e-finance.kpru.ac.th/receipt_research?customer_id=" +
                                                    this.state.rows.REGISTER_ID +
                                                    "&receipt_book=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ORIENTATIN_BOOK +
                                                    "&receipt_no=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ORIENTATIN_NO +
                                                    "&type=u&sign=1"
                                                  }
                                                  target="_blank"
                                                  class="btn btn-primary btn-xs"
                                                  role="button"
                                                >
                                                  ดาวน์โหลดไฟล์ใบเสร็จค่าปฐมนิเทศนักศึกษาใหม่
                                                </a>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </td>
                                        </tr>
                                        {this.state.rows.REGISTER_STATUS_BILL_ROB3_BOOK !== null && (
                                          <>
                                            <tr>
                                              <td>

                                                ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษาส่วนต่างเพิ่มเติม
                                              </td>
                                              <td>
                                                <a
                                                  href={
                                                    "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROB3_BOOK_YEAR +
                                                    "&BOOK_NO=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROB3_BOOK_BOOK +
                                                    "&ID_NO=" +
                                                    this.state.rows.REGISTER_ID +
                                                    "&NO=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROB3_NO +
                                                    "&typeuser=2&countbill=" +
                                                    this.state.rows
                                                      .REGISTER_STATUS_BILL_ROB3_COUNT
                                                  }
                                                  target="_blank"
                                                  class="btn btn-primary btn-xs"
                                                  role="button"
                                                >
                                                  ดาวน์โหลดไฟล์ใบเสร็จค่าธรรมเนียมการศึกษาส่วนต่างเพิ่มเติม
                                                </a>
                                              </td>
                                            </tr>
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
        </div>
      </PresentLayout>
    );
  }
}


